module.exports = __webpack_public_path__ + "static/media/logo_w.afdf2ad2.svg";